// import { CaretDownFilled } from "@ant-design/icons";
import { Select } from "antd";
import React from "react";

import translations from "../../../utils/text/term_translations.json";

const { Option } = Select;

/**
 *
 * @param {string} selectedValue String with currently selected value
 * @param {function} changeHandler Function: change handler for state variable
 * @param {Array} options Array of objects containing value and labels for options
 * @param {string} placeHolderText String with text for placeholder
 * @param {string} labelAttributeName String with name of attribute for label
 * @param {string} valueAttributeName String with name of attribute for value
 *
 * @returns Styled select component
 */
export default function StyledSelect({
  selectedValue,
  changeHandler,
  options,
  placeHolderText,
  labelAttributeName,
  valueAttributeName,
  language,
  ignoreTranslation,
  isDisabled,
}) {
  function getOptionText(element) {
    if (element[valueAttributeName] === "HIST")
      return element[labelAttributeName];
    return language === "en" && !ignoreTranslation
      ? translations[element[labelAttributeName]]
      : element[labelAttributeName];
  }

  return (
    <Select
      // suffixIcon={<CaretDownFilled style={{ color: "black" }} />}
      style={{
        width: "100%",
        fontSize: "20px",
        marginBottom: "10px",
      }}
      placeholder={placeHolderText}
      value={selectedValue}
      optionFilterProp="children"
      onChange={changeHandler}
      disabled={isDisabled}
    >
      {options
        ? options.map((element, i) => {
            return (
              <Option
                style={{ whiteSpace: "nowrap" }}
                value={element[valueAttributeName]}
                key={i}
              >
                {getOptionText(element) ? getOptionText(element).replaceAll('Quarter', 'Trimester') : getOptionText(element)}
              </Option>
            );
          })
        : null}
    </Select>
  );
}
